import React from 'react';
import { Row, Col } from 'antd';
import Link from 'next/link';
import Image from 'components/Image';
import parseCategoryUrl from 'lib/parseCategoryUrl';
import { Title, Text, Category } from 'components/Card';

interface Props {
    $gallery: Gallery;
}

const GalleryItem = ({
    $gallery: { seoSlug, title, category, images, description }
}: Props): React.JSX.Element => (
    <Row gutter={16}>
        <Col span={8}>
            <Link href={`/galerie/${seoSlug}`}>
                <Image
                    type="index"
                    alt={title}
                    height={153}
                    width={272}
                    src={images[0]}
                    style={{ objectFit: 'contain', maxWidth: '100%', height: 'auto' }}
                />
            </Link>
        </Col>
        <Col span={16}>
            {category && (
                <Category>
                    <Link href={parseCategoryUrl(category)}>{category.title}</Link>
                </Category>
            )}
            <Title>
                <Link href={`/galerie/${seoSlug}`}>{title}</Link>
            </Title>
            {description && (
                <Text>
                    <Link href={`/galerie/${seoSlug}`}>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: description
                            }}
                        />
                    </Link>
                </Text>
            )}
        </Col>
    </Row>
);

export default GalleryItem;
